import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Select, MenuItem, Avatar,
  Menu, Box, useMediaQuery,
  InputBase, Divider,  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
 } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
//import logo from '../images/foodsakzsidelogo.png';
import { useCart } from '../context/CartContext';
import { useLanguage } from "../context/LanguageContext";
import DeliveryLocationCard from "./DeliveryLocationCard";
import addressService from "../service/addressService";

const Header = ({onSearch}) => {
     const { t, i18n } = useTranslation();
         const navigate = useNavigate();
     const { cart } = useCart();
  const { user, logout, refreshUser } = useAuth();
  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
    pincode
  } = user || {};

  const [anchorEl, setAnchorEl] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
 const { language, changeLanguage } = useLanguage();
  
   const [openAddressDialog, setOpenAddressDialog] = useState(false);
  
    const isMobile = useMediaQuery('(max-width:768px)');
  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleMenuSelect = (path) => {
    handleCloseMenu();
    if (path === "logout") {
      // Call logout from AuthContext
      handleLogout();
      console.log("Logging out...");
    } else {
      navigate(path);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (onSearch) onSearch(searchQuery);
  };

 {/*const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };*/}
    
      const handleLogin = () => {
     navigate('/login');

  };

  const handleLogout = () => {
    logout(); 
     navigate('/login');

  };
  
  
  const [address, setAddress] = useState({ city: "Chennai", pincode: "600089" });

  const handleAddressChange = (newAddress) => {
    setAddress(newAddress);
    console.log("Updated address:", newAddress);
  };
  

  const [addressFormData, setAddressFormData] = useState({
    userId: userId,
    street1: "",
    street2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    email: email || "",
    phone: "",
  });
  
  const handleSaveAddress = async () => {
    if (!addressFormData.postalCode) {
      alert("Please enter your postal code before proceeding.");
      return;
    }
  if(!addressFormData.street1 || !addressFormData.city || !addressFormData.state || !addressFormData.country || !addressFormData.email || !addressFormData.postalCode){
      alert("Please fill all the details!");
      return;
    }
    
    console.log("userid user"+ userId);
    try {
      addressFormData.userId= userId;
      await await addressService.saveSelectedAddress(userId, addressFormData); 
       const updatedUser = await refreshUser();

      if(updatedUser?.pincode){
     //    setFilters({ brands: [], priceRange: [0, 5000], searchTxt: "" , customerPincode: addressFormData.postalCode, inventoryStatus: ["AVAILABLE", "BACKORDERED"]});
     setOpenAddressDialog(false);
      }
    } catch (error) {
      console.error("Error saving address:", error);
      alert("Failed to save address. Please try again.");
    }
  };
  
  const handleClose = () => {
    setOpenAddressDialog(false);
  };
  
    const handleOpen = () => {
      if(userId){
         navigate('/profile');
          
      }
  
  };
  
  
  
  return (
    <AppBar position="static" color="default"  >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>

{/* Logo */}
<Box
  component="img"
  src={!isMobile ? "../images/foodsakzsidegraylogo.png" : "../images/mobilelogo.png"}
  alt=" FoodSakz Logo"
  sx={{
    height: 60,
    cursor: "pointer",
  }}
  onClick={() => navigate("/")}
/>
       
        {/* Search bar */}
        <Box
          component="form"
          onSubmit={handleSearch}
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "white",
            borderRadius: 2,
            px: 1,
            width: "50%"
          }}
        >
          <InputBase
            placeholder="Search for products..."
            sx={{ ml: 1, flex: 1 }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <IconButton type="submit" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
        </Box>


 <DeliveryLocationCard
  pincode={pincode}
  onChangeAddress={() => handleOpen()}
/>



{!userId ? (
        <>
        <Button variant="outlined" color="inherit" onClick={handleLogin}>
  {t('login' , 'Login')}
        </Button>
 </>
 ) : (

     <>
      {/* Profile & Cart */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton onClick={handleProfileClick}>
            <Avatar alt="User" src="/images/profile.jpg" />
          </IconButton>

          {/* Profile Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
          >
            <MenuItem 
  style={{ 
    fontWeight: 'bold', 
    lineHeight: '1.2', // Keeps the lines close together
    whiteSpace: 'normal', // Allows wrapping (default is usually 'nowrap' in menus)
    wordWrap: 'break-word',
    maxWidth: '150px', // Limits the width so it FORCES the wrap
    display: 'block' 
  }}
>
{name}
</MenuItem>
            <MenuItem onClick={() => handleMenuSelect("/dashboard")}>{t('dashboard' , 'Dashboard')} </MenuItem>
            <MenuItem onClick={() => handleMenuSelect("/profile")}>{t('my_profile' , 'My Profile')} </MenuItem>
            <MenuItem onClick={() => handleMenuSelect("/referral")}>{t('my_referral' , 'My Referral')}</MenuItem>
            <MenuItem onClick={() => handleMenuSelect("/orders")}>{t('my_orders' , 'My Orders')}</MenuItem>
            <MenuItem onClick={() => handleMenuSelect("/cart")}>{t('my_sakz' , 'My Sakz')} <Avatar sx={{ bgcolor: "blue" ,width: 20,height: 20,fontSize: 12}}>{cart.length}</Avatar></MenuItem>
            <MenuItem onClick={() => handleMenuSelect("/refunds")}>{t('my_refunds' , 'My Refunds')}</MenuItem>
            <MenuItem onClick={() => handleMenuSelect("/contact-us")}>{t('contact_us' , 'Contact Us')}</MenuItem>
            <MenuItem onClick={() => handleMenuSelect("logout")}>{t('logout' , 'Logout')}</MenuItem>
          </Menu>
        </Box>
 </>
)}

      <Select
          value={i18n.language}
          onChange={(e) => changeLanguage(e.target.value)}
          variant="outlined"
          size="small"
          sx={{ bgcolor: 'white', color: 'black' }}
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="ta">தமிழ்</MenuItem>
          <MenuItem value="ml">മലയാളം</MenuItem> 
          <MenuItem value="te">తెలుగు</MenuItem>  
          <MenuItem value="kn">ಕನ್ನಡ</MenuItem>  
          <MenuItem value="hi">हिन्दी</MenuItem>  
          <MenuItem value="fr">Français</MenuItem>
          <MenuItem value="es">Español</MenuItem>
          <MenuItem value="ar">العربية</MenuItem>
         
        </Select>
      </Toolbar>

<>
    {/* Address Change Dialog */}
         <Dialog open={openAddressDialog} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle id="address-dialog-title">Complete Your Address Details</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <TextField
              label="Street Line 1"
              value={addressFormData.street1}
              onChange={(e) => setAddressFormData({ ...addressFormData, street1: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Street Line 2"
              value={addressFormData.street2}
              onChange={(e) => setAddressFormData({ ...addressFormData, street2: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="City"
              value={addressFormData.city}
              onChange={(e) => setAddressFormData({ ...addressFormData, city: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="State"
              value={addressFormData.state}
              onChange={(e) => setAddressFormData({ ...addressFormData, state: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Zip Code"
              value={addressFormData.postalCode}
              onChange={(e) => setAddressFormData({ ...addressFormData, postalCode: e.target.value })}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              label="Country"
              value={addressFormData.country}
              onChange={(e) => setAddressFormData({ ...addressFormData, country: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Email ID"
              value={addressFormData.email}
              onChange={(e) => setAddressFormData({ ...addressFormData, email: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Contact Number"
              value={addressFormData.phone}
              onChange={(e) => setAddressFormData({ ...addressFormData, phone: e.target.value })}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 3 }}
              onClick={handleSaveAddress}
            >
              Save Address
            </Button>

          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
    </AppBar>

  );
};

export default Header;
